import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TEmManagementListResponseItem } from 'redux/reducers/emManagement/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';
import {
	ACTIVE_SERVICES_FILTER_OPTIONS,
	EActiveSerrvicesKeys,
	EActiveSerrvicesNames,
	EEmStatus,
} from './constants';

export const tableStructure: TTableStructure<keyof TEmManagementListResponseItem>[] = [
	{
		name: 'Status',
		selector: 'status',
		noName: true,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		// type: ETableStructureType.STATUS,
		filter: [
			[EEmStatus.ACTIVE, 'Active'],
			[EEmStatus.BLOCKED, 'Blocked'],
			// [null, 'Error'],
		],
		// colors: [
		// 	['Active', 'success.light'],
		// 	['Deactivated', 'warning.light'],
		// 	['Blocked', 'error.light'],
		// 	[null, 'error.light'],
		// ],
		type: ETableStructureType.ICON,
		icons: [
			{
				value: EEmStatus.ACTIVE,
				icon: EIconButtons.CHECK_CIRCLE,
			},
			{
				value: EEmStatus.DEACTIVATED,
				icon: EIconButtons.BLOCK,
				color: 'warning',
			},
			{
				value: EEmStatus.BLOCKED,
				icon: EIconButtons.CANCEL,
				color: 'error',
			},
			{
				value: null,
				icon: EIconButtons.ERROR_OUTLINE,
				color: 'error',
			},
		],

		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'EM ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Identifier',
		selector: 'identifier',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Full Name',
		selector: 'fullName',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'TIN Number',
		selector: 'tinNumber',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Registered Country',
		selector: 'registeredCountry',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Legal Status',
		selector: 'legalStatus',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['not_established_in_eu', 'Non-EU'],
			['established_in_eu', 'EU'],
			[null, 'Error'],
		],
		colors: [
			// ['not_established_in_eu', 'warning.light'],
			// ['established_in_eu', 'info.light'],
			[null, 'error.light'],
		],
	},
	{
		name: 'Price Inclusive VAT',
		selector: 'priceInclusiveVat',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Monthly Subscription',
		selector: 'reportingFeeTypeName',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EAS VAT used',
		selector: 'nonEuCountriesUsingEasVatReg',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE_ARRAY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Available Schemes',
		selector: 'availableSchemes',
		show: false,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS_ARRAY,
		align: ETableStructureAlign.LEFT,
		filter: [
			['IOSS', 'IOSS'],
			['OSS_Union', 'OSS Union'],
			['OSS_NON_UNION', 'Non-Union'],
			['NON_EU_SUPPORTED_COUNTRY', 'Non-EU'],
		],
		// colors: [
		// 	['IOSS', '#BBDEFB'],
		// 	['OSS_Union', '#E1BEE7'],
		// 	['OSS_NON_UNION', '#FFCC80'],
		// 	['NON_EU_SUPPORTED_COUNTRY', '#FFCDD2'],
		// ],
	},
	{
		name: 'Fee Mode',
		selector: 'feeClass',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['manual', 'Manual'],
			['auto', 'Auto'],
			[null, 'Error'],
		],
		colors: [
			// ['manual', 'info.light'],
			['auto', 'primary.light'],
			[null, 'error.light'],
		],
	},
	{
		name: 'Disabled At',
		selector: 'disabledAt',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
	},
	{
		name: 'Is Swiss',
		selector: 'isSwiss',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
		filter: [
			['true', 'Swiss'],
			['false', 'Non-Swiss'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'warning.light'],
		],
	},
	{
		name: 'Created',
		selector: 'created',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
	},
	{
		name: 'Is GPSR',
		selector: 'isGpsr',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'error.light'],
		],
	},
	{
		name: 'IOSS Registered',
		selector: 'iossRegistered',
		show: false,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'warning.light'],
		],
	},
	{
		name: 'Active Services',
		selector: 'activeServices',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS_ARRAY,
		align: ETableStructureAlign.LEFT,
		filter: ACTIVE_SERVICES_FILTER_OPTIONS,
		// colors: [
		// 	['IOSS', '#90CAF9'],
		// 	['OSS', '#CE93D8'],
		// 	['NON UNION', '#FFB74D'],
		// 	['SWISS', '#ffa09e'],
		// 	['GB', '#66BB6A'],
		// 	['GPSR', '#05dbc7'],
		// ],
	},
	{
		name: 'Site Integration Type',
		selector: 'siteIntegrationType',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['csv', 'csv'],
			['api', 'api'],
			['plugin', 'plugin'],
		],
	},
	{
		name: 'Support Manager',
		selector: 'supportManager',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},

	// {
	// 	name: 'Is Swiss',
	// 	selector: 'isSwiss',
	// 	show: false,
	// 	sortable: false,
	// 	filterable: true,
	// 	colSpan: 1,
	// 	type: ETableStructureType.BOOLEAN,
	// 	align: ETableStructureAlign.LEFT,
	// 	filter: [
	// 		['true', 'Swiss'],
	// 		['false', 'Non-Swiss'],
	// 	],
	// 	colors: [
	// 		['true', 'success.light'],
	// 		['false', 'warning.light'],
	// 	],
	// },
];
